import e from "../../../@babel/runtime/helpers/esm/typeof2.mjs";
var o = (typeof navigator > "u" ? "undefined" : e(navigator)) === "object" && /Firefox/i.test(navigator.userAgent);
export {
  o as default
};
//# sourceMappingURL=isFirefox.mjs.map
